import React, { useRef, useState, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import Spinner2 from "../../common/Spinner/Spinner2";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { getTrailers, fetchSavedView, baseUrl  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { Button, Grid } from '@mui/material';
import ModalComponent from '../../common/Modal/ModalComponent';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton';
import ResourceDetails from '../../../../shared/common-utilities/common/ResourceDetails/ResourceDetails';
import WindowComponent from '../../common/Window/WindowComponent';
import i18_en from '../../../../jsonStore/i18_en.json';
import { MessageComponent, RenderActionButtons } from '../../../../shared/common-utilities/common/DeleteConfirmationComponent';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';

const entity = "trailer";
let entityNameFor = "trailer";
const odataApiName = "trailers";
let odataApiNameFor = "trailers";
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};
//#region SortData start


const Trailer = (props) => {
    //#region Reference
    const trailerGrid = useRef(null);
    //#endregion Reference

    //#region Hook Selctor
    //#endregion Hook Selctor

    const trailerGriddDtaItemKey = "id";
    const initialSort = service.initialSort[entity];

    //#region States - Get set variables  
    const [tempTrailerData, setTempTrailerData] = useState([]);
    const [trailerGridColumnList, setTrailerGridColumnList] = useState(null);
    const [tempTrailerGridColumnList, setTempTrailerGridColumnList] = useState(null);

    const [isLoading, setIsLoading] = React.useState(false);
    const [isTrailer, setIsTrailer] = useState(true);
    const [loadedGridData, setLoadedGridData] = useState(tempTrailerData);
    const [myGridData, setmyGridData] = React.useState([]);
    const [loadSelectionValue, setloadSelectionValue] = useState(100);
    const [totalData, setTotalData] = useState();
    const userID = localStorage.getItem('userID');

    const [isApiLoaded, setIsApiLoaded] = useState(false);
    const [paramsData, setParamsData] = useState(null);
    let [initialFilter, setInitialFilter] = useState([]);
    const [nextDataUrl, setNextDataUrl] = useState(null);
    const [initialSaveViewData, setInitialSaveViewData] = useState([]);
    const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
    const [trailerData, setTrailerData] = useState({});
    const [trailerResource,setTrailerResource] = useState({});
    const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [errorSnackbarMessageTrailer, setErrorSnackbarMessageTrailer] = useState('');
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isResourceLoad, setIsResourceLoad] = useState(false);
    const [changeToChildTrailer, setChangeToChildTrailer] = useState(null);
    const [isApiCallRequired, setIsApiCallRequired] = useState(true);
    const [openConfirmationModal, setopenConfirmationModal] = useState(false);
    const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    const [canExecute, setCanExecute] = useState([]);

    const trailerDetails = [
        { label: 'Trailer Code', value: trailerResource[0]?.codeTrailer },
        { label: 'Trailer / Chassis ', value: trailerResource[0]?.trailerChassis },
        { label: 'Brand ', value: trailerResource[0]?.brand },
        { label: 'Number Plate', value: trailerResource[0]?.numberplate },
    ];
    const trailerFilterComponents = [];
    const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))
    //#endregion States

    //#region Hooks  

    useEffect(() => {
        // setIsLoading(true);

        setIsApiLoaded(true);
        odataApiNameFor = odataApiName;
        entityNameFor = entity;
        if (props?.gridFlagVal) {
            odataApiNameFor += props?.gridFlagVal;
            entityNameFor += props?.gridFlagVal;
        }
        setGridColumns(entity);
        let tempFilterData = [];
        if (props?.resourceType) {
            tempFilterData = [
                {field: 'trailerChassis', value: props?.resourceType ==="trailerCode" ? '=Trailer' : "Chassis", isLast: false, type: 'Edm.String', isViewFilter: false}];
            setInitialFilter(tempFilterData);
        }
        let userData = service.getUserFilterData(entity);
        const mergedArray = tempFilterData.concat(userData);
        setInitialFilter(mergedArray);

    }, []);

    const setGridColumns = (entityName) => {
        const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
        if (!_.isNil(columnList)) {
          setTrailerGridColumnList(JSON.parse(columnList));
          getColList(JSON.parse(columnList));
          return true;
        }
    
        if(!_.isNil(metaData) || metaData !== "undefined") {
            service.entityDefinitions(metaData, entityName).then((tempFieldList) => {
                localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
                setTrailerGridColumnList(tempFieldList);
                getColList(tempFieldList);
            })
        }
    }

    const getDefaultColList = (dcolsStringTR, gridcolumns) => {
        const dColsTR = JSON.parse(localStorage.getItem("defaultColumnSetting"));
        if (!_.isNil(dcolsStringTR) && dcolsStringTR != "undefined" ) {
          const defaultColumnListTR = gridcolumns?.filter(item => {
            return dColsTR[entity]?.split("~").includes(item.field);
          });
          if (defaultColumnListTR.length == 0) {
            localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
            setTempTrailerGridColumnList(gridcolumns);
          } else {
            const sortedArr = _.sortBy(defaultColumnListTR, function (item) { return dColsTR[entity]?.split("~").indexOf(item.field) });
            localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
            setTempTrailerGridColumnList(sortedArr);

            const arr1 = sortedArr;
            const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
            const newsortedArr = _.concat(arr1, arr2);
            setTrailerGridColumnList(newsortedArr);
          }
        } else {
          localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
          setTempTrailerGridColumnList(gridcolumns);
        }
    }

    const getColList = (gridcolumns) => {
        const trailerUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
        const dcolsStringTrailer = localStorage.getItem("defaultColumnSetting");
        apiService.get(trailerUrl).then(savedViewRes => {
          if (savedViewRes?.value?.length > 0) {
            apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResTrailer => {
                if (readResTrailer !== undefined && readResTrailer !== null) {
                    setInitialSaveViewData(savedViewRes.value);
                    setInitialFetchReadLinkData(readResTrailer);
                    const defaultViewExist = readResTrailer[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
                    if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
                        setCanExecute(defaultViewExist);
                        const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
                        if (favFilterExist?.length > 0) {
                            setTempTrailerGridColumnList(defaultViewExist[0].columns);
                        }
                    } else if (readResTrailer[odataApiNameFor]?.columns?.length !== 0) {
                        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResTrailer[odataApiNameFor]?.columns));
                        setTempTrailerGridColumnList(readResTrailer[odataApiNameFor]?.columns);
                    } else {
                        getDefaultColList(dcolsStringTrailer, gridcolumns);
                    }
                }
            })
          } else {
            getDefaultColList(dcolsStringTrailer, gridcolumns);
          }
    
          setIsLoading(false);
        });
    }

    useEffect((e) => {
        if (!_.isNil(paramsData) && isApiCallRequired) {
            updateSendApi(loadSelectionValue);
        } else {
            setIsApiCallRequired(true);
        }
    }, [paramsData]);

    useEffect((e) => {
        if (!_.isNil(tempTrailerGridColumnList)) {
            setNextDataUrl(null);
            updateSendApi(loadSelectionValue);
        }
    }, [tempTrailerGridColumnList]);

    useEffect(()=>{
        if (!_.isNil(props.resourceData)) {
            const url = `${baseUrl}/trailers?&$filter=(codeTrailer eq '${props?.resourceData}')`;
          apiService.get(url).then(res => {
            if (res !== null && res !== undefined) {
                setTrailerResource(res.value);
                setIsResourceLoad(true);
            }
          })
        }
    },[])

    //#endregion Hooks

    //#region Methods

    // --- API's Call START ---

    const sendApi = (val, size) => {
        let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
        let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
        if (canExecute?.length > 0) {
            return;
        }
        if (tempTrailerGridColumnList !== null && tempTrailerGridColumnList !== undefined && tempTrailerGridColumnList.length > 0) {
            setIsLoading(true);
            const params = '&' + filter + '&' + orderby + '&$count=true';
            const columns = tempTrailerGridColumnList?.map(item => item.field);
            const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
            if (!_.isNull(mandatroyEntity)) {
                let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
                splitedColums.forEach(element => {
                if (!columns.includes(element)) {
                    columns.push(element)
                }
                });
            }

            const selectFields = `&$select=${columns}`;
            const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
            apiService.get(getTrailers, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
                if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
                    setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
                    if (response?.error?.message?.includes('$orderby')) {
                      const sortToRemoveTrailer = response.error.message.split("'")[1];
                      setChangeToChildTrailer({ type: "sort", value: sortToRemoveTrailer });
                    } else if (response?.error?.code == "Application_FilterErrorException") {
                      const filterToRemoveTrailer = response.error.message.split("'")[1];
                      setChangeToChildTrailer({ type: "filter", value: filterToRemoveTrailer });
                    }
                } else {
                    if (response.value) {
                        setTotalData(response["@odata.count"]);
                        let tempData = [];
                        if (val == 'Scroll' && tempTrailerData !== null && tempTrailerData !== undefined && tempTrailerData.length > 0) {
                            tempTrailerData.forEach(tempTrailer => {
                                tempData.push(tempTrailer);
                            });
                            response.value.map(temp => {
                                tempData.push(temp)
                            })
                        }
                        // Update the data based on the response
                        else {
                            tempData = response.value;
                        }
    
                        tempData = service.setColorCodeAndDate(tempData, trailerGridColumnList);
                        if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
                            setNextDataUrl(response['@odata.nextLink']);
                        }
    
                        setTempTrailerData(tempData);
                        setmyGridData(tempData);
                        setLoadedGridData(tempData);
                        setIsApiLoaded(true);
                    }
                } 
            })
                .catch(error => {
                    console.error('API error:', error);
                })
                .finally(() => {
                    setIsLoading(false);
                    if (props?.sendDataToParent) {
                        props.sendDataToParent(odataApiName);
                    }
                });
        } else {
            setIsLoading(false);
        }
    }

    const updateSendApi = useMemo(() => {
        return _.debounce((size) => {
          sendApi(null, size);
        }, 250);
    }, [sendApi]);

    // --- API's Call END ---

    const childStateHandler = (value, flag) => {
       if (flag === 'showGridHeader') {
            setIsTrailer(value);
        } else if (flag === 'getData') {
            setNextDataUrl(null);
            setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
            setIsApiCallRequired(value.isApiCall);
            setTempTrailerGridColumnList(value.columns);
            setCanExecute([]);
        } else if (flag === 'selectedValues') {
            gridSelectedValues = value;
        } else if (flag === 'dataItem') {
            setTrailerData(value);
        } else if (flag === 'refresh') {
            sendApi(null, loadSelectionValue);
        }  else if (flag === 'columnsVisible') {
            setTempTrailerGridColumnList(value);
        }
    }

    // --- Common methods END ---

    //#endregion Methods

    //#region Not in use

    //#endregion

    const closePopup = () => {
        props.onClose();
    }

    const onOkClick = () => {
        let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
        if (transferdataId.length === 0) {
            setErrorSnackbarMessageTrailer(`Please select ${props?.resourceType === "trailerCode" ? "trailer" : "chessis"} resource`);
            setErrorSnackbarOpen(true);
            return;
        }
        props?.addResourceApi(trailerData);
        // props.onClose();
    }

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setErrorSnackbarOpen(false);
    };

    const deAllocateResource = () => {
        props?.addResourceApi({codeTrailer:""});
    }

    const onLoadSelectionChangeTrailer = (e) => {
        let value = e.value;
        setloadSelectionValue(value);
        sendApi(null, value);
    }

    const setErrorParameterAndMessage = (errMsg) => {
        setCommonPopupParameters({
          title: 'Error'
        });
        setErrorMessage(errMsg);
        setopenConfirmationModal(true);
    }

    const closeConfirmationModalTrailer = () => {
        setopenConfirmationModal(false);
    }

    return (
        <>
            {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
            <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

                <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessageTrailer} handleErrorSnackbarClose={handleErrorSnackbarClose} />
                {
                    props.resourceData != null && isResourceLoad && (
                        <>
                        {trailerResource.length > 0 ? (
                            <>
                                <ResourceDetails details={trailerDetails} onDeallocate={() => setIsDeleteDialogOpen(true)} />
                            </>
                        ) : (
                            <Typography color="#ce0000" variant="body2" sx={{fontWeight:'bold',paddingBottom:'7px',textAlign:'center'}}> Allocated {props?.resourceType ==="trailerCode" ? 'Trailer' : "Chassis"} ({props?.resourceData}) doesn't exists!</Typography>
                        )}
                        </>
                    )
                }
                {isTrailer &&
                    <Box className="headBG" sx={{ px: 1, width: '100%', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Trailer</Typography>
                    </Box>
                }

                <Grid container sx={{ marginTop: 0 }} className='filterbar-bg'>
                    <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
                        {isApiLoaded && <DataGridComponent
                            {...props}
                            gridRef={trailerGrid}
                            gridFlagVal={odataApiName}
                            gridFlagValFor={odataApiNameFor}
                            gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px', maxWidth: 'calc(100%)', width: '100%' }}
                            entity={entity}
                            gridNewData={myGridData}
                            loadedGridData={loadedGridData}
                            tempGridData={tempTrailerData}
                            gridColumnList={trailerGridColumnList ? trailerGridColumnList : []}
                            gridTempColumnList={tempTrailerGridColumnList ? tempTrailerGridColumnList : []}
                            gridSort={initialSort}
                            isItemVisible={false}
                            gridInitialFilter={initialFilter}
                            isShowGridHeader={isTrailer}
                            griddDtaItemKey={trailerGriddDtaItemKey}
                            gridDraggable={false}
                            sendDataToParent={childStateHandler}
                            gridDataAction={dataRelatedAction}
                            gridFilterComponents={trailerFilterComponents}
                            onLoadSelectionChange={onLoadSelectionChangeTrailer}
                            loadSelectionValue={loadSelectionValue}
                            gridtotalData={totalData}
                            initialSaveViewData={initialSaveViewData}
                            initialFetchReadLinkData={initialFetchReadLinkData}
                            selectableMode={"single"}
                            changeToChild={changeToChildTrailer}
                        />}
                    </Grid>
                </Grid>
            </Grid>
            {isDeleteDialogOpen && <WindowComponent title={i18_en.confirmDeallocateRes} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={200} minWidth={400} minHeight={200} onClose={() => setIsDeleteDialogOpen(false)} dataComponent={MessageComponent} actionButtons={<RenderActionButtons onClose={() => setIsDeleteDialogOpen(false)} onConfirm={deAllocateResource}/>} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}
            {
                props?.openAddColumnModal && (
                    <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
                )
            }
            <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModalTrailer} />
        </>
    )
};

export default Trailer;
